import api from '@/libs/axiosInstance';
import type { ApiResponse, ProgramTrackingSettings } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export const programTrackingQueryKey = (brandId: string, programId: string) =>
  ['program-tracking', brandId, programId] as const;

export const useProgramTrackingQuery = (brandId: string | undefined, programId: string) =>
  useQuery({
    queryKey: programTrackingQueryKey(brandId ?? '', programId),
    queryFn: async (): Promise<ProgramTrackingSettings> => {
      const { data } = await api.get<ApiResponse<ProgramTrackingSettings>>(
        `/dashboard/programs/${programId}/tracking`
      );
      if (!data.success || !data.data) throw new Error(data.message);
      return data.data;
    },
    enabled: Boolean(brandId && programId),
  });
